
function JobIcon() {
	return (
		<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M14.6875 19.6875C17.1037 19.6875 19.0625 17.7287 19.0625 15.3125C19.0625 12.8963 17.1037 10.9375 14.6875 10.9375C12.2713 10.9375 10.3125 12.8963 10.3125 15.3125C10.3125 17.7287 12.2713 19.6875 14.6875 19.6875Z"
				stroke="white"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="square"
			/>
			<path
				d="M14.6875 13.4375V17.1875"
				stroke="white"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="square"
			/>
			<path
				d="M12.8125 15.3125H16.5625"
				stroke="white"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="square"
			/>
			<path d="M5.9375 0.9375V3.4375" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" />
			<path d="M14.6875 0.9375V3.4375" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" />
			<path d="M19.6875 7.1875H0.9375" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
			<path
				d="M7.8125 18.4375H2.8125C1.77688 18.4375 0.9375 17.5981 0.9375 16.5625V5.3125C0.9375 4.27688 1.77688 3.4375 2.8125 3.4375H17.8125C18.8481 3.4375 19.6875 4.27688 19.6875 5.3125V9.6875"
				stroke="white"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="square"
			/>
		</svg>
	);
}

export default JobIcon;
